import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCucumberComponent } from './simple-icons-cucumber.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCucumberComponent ],
    exports:      [ SimpleIconsCucumberComponent ],
    bootstrap:    []
})
export class SimpleIconsCucumberModule {}
